import { Table } from 'antd'
import useCheckMobileDevice from 'hooks/useCheckMobileDevice'

function ResponsiveTable(props) {
  const { isMobile } = useCheckMobileDevice()
  return <Table size={isMobile ? 'small' : 'middle'} {...props} />
}

export default ResponsiveTable
